/**
 * RTK Query / fetch header helper: only set Authorization when a real JWT is present
 * (never send the literal `Bearer undefined`, which breaks optional auth and user lookup).
 */
export function bearerAuthHeaders(
  token: string | null | undefined
): Record<string, string> {
  if (
    token == null ||
    String(token) === "undefined" ||
    String(token).trim() === ""
  ) {
    return {};
  }
  return { Authorization: `Bearer ${String(token)}` };
}
